export default __webpack_public_path__ + "static/media/ea28972f0ca4eb85.2624c8c942e38ce0322f05c61387a2d9.svg";